import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { TermRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/term-request';
import { LeanTerm } from 'src/app/assabil-kernel/models/entities/control-tables/lean-term';



@Component({
  selector: 'term-list',
  templateUrl: './term-list.component.html',
  styleUrls: ['./term-list.component.scss']
})

export class TermListComponent extends BasePage2<LeanTerm> {


  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  terms: LeanTerm[] = [];
  // ---------------------------------------------------
  
  // ---------------------------------------------------

  constructor(
      protected toastr                : ToastrService,
      protected router                : Router,
      protected baseService           : BaseService,
      protected leanUtilsService      : LeanUtilsService,
      protected controlTablesService  : ControlTablesService,
      protected location              : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName =  "term";
  }
  // ---------------------------------------------------

    
  // ---------------------------------------------------
  getRows(): LeanTerm[] {
      return this.terms;
  }
  // ---------------------------------------------------


//----------------------------------------------------------------------
saveRow(row: LeanTerm): Promise<LeanTerm> {
    let request: TermRequest = new TermRequest(this.controlTablesService.getUserInfo());
    request.term = row;
    return this.controlTablesService.save(this.entityName, request);
}
//----------------------------------------------------------------------

  
//----------------------------------------------------------------------
  new(){
      let entity : LeanTerm = new LeanTerm();
      entity.inserted = true;
      entity.edit = true;
      this.terms.push(entity);
      this.terms = [...this.terms];
    }
//----------------------------------------------------------------------

        
//----------------------------------------------------------------------
  loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.terms = result;
    })
  }
  // ---------------------------------------------------

}